module.exports = __webpack_public_path__ + "img/LindsayHopkinscourts-v-474x632.46c046c2.jpg";